import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

/**
 * DomHandlerService
 *
 * Safe wrapper around browser-only APIs (window/document).
 * Prevents SSR crashes and navigation-side effects.
 */
@Injectable({
  providedIn: 'root'
})
export class DomHandlerService {
  /**
   * True when running in browser (not SSR)
   */
  private readonly isBrowser: boolean;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  get winDocument() {
    return this.document;
  }

  get window(): any {
    if (this.isBrowser) {
      return window;
    }
  }

  /**
   * Smooth scrolls window to position.
   * Safe for navigation transitions.
   */
  winScroll(y: number, x: number) {
    if (!this.isBrowser) return;

    window.requestAnimationFrame(() => {
      window.scrollTo({
        top: y,
        left: x,
        behavior: 'smooth'
      });
    });
  }

  /**
   * Hides the initial app preloader safely.
   * Prevents errors if element is already removed.
   */
  hidePreloader() {
    if (!this.isBrowser) return;

    window.requestAnimationFrame(() => {
      const el = this.document.getElementById('preloader');
      if (el) {
        el.classList.add('hide');
      }
    });
  }
}
